import React from "react";
import Typewriter from "typewriter-effect";

export default function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "   Java Developer",
          "   Software Developer",
          "   Python Developer",
          "   Competitive Coder",
          "   Frontend Developer"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 30,
      }}
    />
  );
}